<template>
  <div class="landing-container" :class="theme">
    <!-- Navbar Flutuante -->
    <div class="nav-wrapper">
      <nav class="floating-nav">
        <!-- Logo -->
        <div class="nav-logo">
          <!-- Logo muda conforme o tema -->
          <img v-if="theme === 'dark'" src="@/assets/images/logo-branco.svg" alt="OligoCheck" />
          <img v-else src="@/assets/images/logo-azul.svg" alt="OligoCheck" />
        </div>

        <!-- Links Centrais -->
        <div class="nav-links">
          <a href="#" class="nav-link">O Aparelho</a>
          <a href="#" class="nav-link">Tecnologia</a>
          <a href="#" class="nav-link">Benefícios</a>
          <a href="#" class="nav-link">Depoimentos</a>
        </div>

        <!-- Ações Direita -->
        <div class="nav-actions">
          <!-- Botão de Tema -->
          <button class="icon-btn theme-toggle" @click="toggleTheme" title="Alternar Tema">
            <svg v-if="theme === 'dark'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"/><path d="M12 1v2"/><path d="M12 21v2"/><path d="M4.22 4.22l1.42 1.42"/><path d="M18.36 18.36l1.42 1.42"/><path d="M1 12h2"/><path d="M21 12h2"/><path d="M4.22 19.78l1.42-1.42"/><path d="M18.36 5.64l1.42-1.42"/></svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>
          </button>

          <div class="divider"></div>

          <div class="lang-selector">
            <img src="https://flagcdn.com/w20/es.png" alt="ES" class="flag" />
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>
          </div>

          <a href="https://api.whatsapp.com/send/?phone=34617488404" target="_blank" class="nav-cta">
            <span>Comprar Agora</span>
          </a>
        </div>
      </nav>
    </div>

    <!-- Hero Section -->
    <header class="hero">
      <div class="container hero-content">
        <div class="hero-text-col">
          <div class="badge">
            <span>Para Profissionais de Saúde</span>
          </div>
          <h1 class="titulo">
            Potencialize sua Clínica com<br />
            <span class="destaque-texto">OligoCheck</span>
          </h1>
          <p class="subtitulo">
            A ferramenta definitiva para Nutricionistas, Médicos e Terapeutas.
            Avalie minerais, metais pesados e estresse oxidativo em tempo real.
            Aumente seu faturamento e a fidelização dos seus pacientes.
          </p>
          
          <div class="cta-group">
            <a href="https://api.whatsapp.com/send/?phone=34617488404" target="_blank" class="botao-principal laranja">
              <span>Adquirir Equipamento</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
            </a>
            <button class="botao-secundario">
              Ver Demonstração
            </button>
          </div>
        </div>

        <!-- Nova Imagem Hero (Dashboard/Device) -->
        <div class="hero-image-container">
          <div class="hero-glow"></div>
          <img src="@/assets/images/hero-device.png" alt="Plataforma OligoCheck" class="hero-device-img floating-anim" />
        </div>
      </div>
    </header>

    <!-- Nova Seção: Como Funciona -->
    <section class="como-funciona">
      <div class="container cf-grid">
        <div class="cf-image-wrapper">
          <!-- Placeholder visual para o relatório -->
          <div class="report-card floating-anim">
            <img src="@/assets/images/laudo-exemplo.webp" alt="Exemplo de Laudo OligoCheck" class="report-img" />
            
            <!-- Overlay de Visualização -->
            <div class="report-overlay">
              <button class="btn-visualizar">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>
                Visualizar Ampliado
              </button>
            </div>
          </div>
          <!-- Efeito de brilho atrás -->
          <div class="glow-effect"></div>
        </div>

        <div class="cf-text">
          <h2 class="section-title">Como Funciona o <span class="destaque-texto">OligoCheck?</span></h2>
          <p class="cf-desc">
            Oligocheck é a única tecnologia capaz de ler oligoelementos a nível intracelular, desde a palma da mão do paciente, com resultados imediatos na tela do seu computador.
          </p>
          
          <div class="cf-features">
            <div class="cf-feature-item">
              <div class="cf-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
              </div>
              <div class="cf-info">
                <strong>21 Minerais</strong>
                <span>Avaliação completa de deficiências</span>
              </div>
            </div>

            <div class="cf-feature-item">
              <div class="cf-icon warning">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
              </div>
              <div class="cf-info">
                <strong>15 Metais Pesados</strong>
                <span>Detecção de intoxicação</span>
              </div>
            </div>

            <div class="cf-feature-item">
              <div class="cf-icon success">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>
              </div>
              <div class="cf-info">
                <strong>7 Vitaminas</strong>
                <span>Análise de biodisponibilidade</span>
              </div>
            </div>

            <div class="cf-feature-item">
              <div class="cf-icon info">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"/><line x1="16" y1="8" x2="2" y2="22"/><line x1="17.5" y1="15" x2="9" y2="15"/></svg>
              </div>
              <div class="cf-info">
                <strong>+ Indicadores</strong>
                <span>Pele, Cabelo, Fígado e mais...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


    <!-- Como Funciona (Processo) - Movido para cá -->
    <section class="steps-section">
      <div class="container">
        <div class="section-header">
          <h2>Agilidade na <span class="texto-laranja">Consulta</span></h2>
          <p>Otimize seu tempo e entregue valor imediato ao paciente.</p>
        </div>

        <div class="steps-grid">
          <div class="step-item">
            <div class="step-icon-wrapper">
              <div class="step-number">1</div>
              <div class="step-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z"/><path d="M12 14c-4.42 0-8 1.79-8 4v2h16v-2c0-2.21-3.58-4-8-4z"/></svg>
              </div>
            </div>
            <h4>Colocação do Sensor</h4>
            <p>Posicionamento na palma da mão do paciente em 4 pontos estratégicos.</p>
          </div>
          
          <div class="step-connector">
            <div class="line-anim"></div>
          </div>
          
          <div class="step-item">
            <div class="step-icon-wrapper">
              <div class="step-number">2</div>
              <div class="step-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
              </div>
            </div>
            <h4>Escaneamento Rápido</h4>
            <p>Espectrofotometria realiza a leitura celular em apenas alguns segundos.</p>
          </div>
          
          <div class="step-connector">
            <div class="line-anim delay-1"></div>
          </div>
          
          <div class="step-item">
            <div class="step-icon-wrapper">
              <div class="step-number">3</div>
              <div class="step-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8h1a4 4 0 0 1 0 8h-1"/><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/><line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/></svg>
              </div>
            </div>
            <h4>Processamento</h4>
            <p>Análise instantânea na plataforma SO/Check eHealth 4.0 na nuvem.</p>
          </div>

          <div class="step-connector">
            <div class="line-anim delay-2"></div>
          </div>

          <div class="step-item">
            <div class="step-icon-wrapper">
              <div class="step-number">4</div>
              <div class="step-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
              </div>
            </div>
            <h4>Relatório Completo</h4>
            <p>Resultados detalhados com interpretação e recomendações automáticas.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- O que analisamos - (REMOVIDO "Análise Completa e Imediata" como solicitado) -->

    <!-- Espectrofotometria & Ciência -->
    <section class="science-section">
      <div class="container">
        <div class="science-content">
          <!-- Lado Esquerdo: Visual do Dispositivo -->
          <div class="science-visual">
            <div class="device-showcase floating-anim">
              <!-- Certifique-se de salvar a imagem como 'espectrofotometro.png' na pasta assets/images -->
              <img src="@/assets/images/espectrofotometro.png" alt="Sensor OligoCheck" class="device-img" />
              <div class="device-glow"></div>
            </div>
          </div>

          <!-- Lado Direito: Conteúdo -->
          <div class="science-text">
            <div class="badge-science">Ciência Pura</div>
            <h2>O Poder da <span class="texto-azul">Espectrofotometria</span></h2>
            <p class="science-intro">
              O OligoCheck utiliza a espectrofotometria, uma metodologia analítica quantitativa que mede a absorção ou densidade óptica de uma substância química.
            </p>
            
            <div class="science-features">
              <div class="sc-item">
                <div class="sc-dot"></div>
                <p>Baseia-se no princípio de que cada composto químico absorve, emite ou reflete luz em um determinado comprimento de onda.</p>
              </div>
              <div class="sc-item">
                <div class="sc-dot"></div>
                <p>Tecnologia utilizada extensivamente em laboratórios clínicos, industriais e ambientais para análises quantitativas.</p>
              </div>
            </div>

            <!-- Card Artigos Científicos -->
            <div class="articles-card">
              <div class="art-header">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>
                <span>Evidência Científica</span>
              </div>
              <div class="art-list">
                <a href="#" class="article-link">
                  <span>Validation of Spectrophotometry in Clinical Use</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                </a>
                <a href="#" class="article-link">
                  <span>Heavy Metals Analysis: Comparative Study</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Comparativo Section -->
    <section class="comparative-section">
      <div class="container">
        <div class="section-header">
          <h2>Evolua sua <span class="texto-azul">Diagnose</span></h2>
          <p>Entenda por que o OligoCheck é o complemento perfeito para sua prática clínica.</p>
        </div>

        <div class="comparison-table-wrapper">
          <table class="comparison-table">
            <thead>
              <tr>
                <th class="feature-col">Característica</th>
                <th class="traditional-col">Exame de Sangue (Soro)</th>
                <th class="oligocheck-col">
                  <div class="logo-th">
                    <img src="@/assets/images/logo-azul.svg" alt="OligoCheck" />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="feature-name">Tipo de Análise</td>
                <td>
                  <span class="status-tag neutral">Extracelular (Soro)</span>
                  <small>Mostra o que circula no momento (homeostase).</small>
                </td>
                <td>
                  <span class="status-tag success">Intracelular (Tecidual)</span>
                  <small>Mostra o estoque real e biodisponibilidade.</small>
                </td>
              </tr>
              <tr>
                <td class="feature-name">Tempo de Resultado</td>
                <td>
                  <span class="status-tag warning">Dias ou Semanas</span>
                </td>
                <td>
                  <span class="status-tag success">Imediato (Tempo Real)</span>
                </td>
              </tr>
              <tr>
                <td class="feature-name">Coleta</td>
                <td>
                  <span class="status-tag warning">Invasiva (Agulha)</span>
                  <small>Desconforto para o paciente.</small>
                </td>
                <td>
                  <span class="status-tag success">Não Invasiva (Luz)</span>
                  <small>Indolor, ideal para crianças e idosos.</small>
                </td>
              </tr>
              <tr>
                <td class="feature-name">Metais Pesados</td>
                <td>
                  <span class="status-tag neutral">Circulantes (Agudo)</span>
                  <small>Só detecta intoxicação muito recente.</small>
                </td>
                <td>
                  <span class="status-tag success">Acumulados (Crônico)</span>
                  <small>Detecta metais estocados nos tecidos.</small>
                </td>
              </tr>
              <tr>
                <td class="feature-name">Custo Operacional</td>
                <td>
                  <span class="status-tag neutral">Logística de Amostra</span>
                </td>
                <td>
                  <span class="status-tag success">Sem Insumos/Logística</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <!-- Benefícios Section -->
    <section class="benefits-section">
      <div class="container">
        <div class="section-header">
          <div class="badge-users">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            +12.000 Usuários no Mundo
          </div>
          <h2>Benefícios de Incorporar o <span class="texto-azul">OligoCheck</span></h2>
          <p>Leve sua consulta para o próximo nível com tecnologia de ponta.</p>
        </div>

        <div class="benefits-grid">
          <!-- Item 1 -->
          <div class="benefit-card">
            <div class="benefit-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="22" y1="12" x2="18" y2="12"/><line x1="6" y1="12" x2="2" y2="12"/><line x1="12" y1="6" x2="12" y2="2"/><line x1="12" y1="22" x2="12" y2="18"/></svg>
            </div>
            <div class="benefit-content">
              <h3>Tecnologia de Alta Precisão</h3>
              <p>Utilizamos espectrofotometria, tecnologia ultrassensível que permite uma leitura precisa e confiável.</p>
            </div>
          </div>

          <!-- Item 2 -->
          <div class="benefit-card">
            <div class="benefit-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            </div>
            <div class="benefit-content">
              <h3>Atendimento Personalizado</h3>
              <p>Compartilhe resultados na tela em tempo real, interprete e faça recomendações 100% personalizadas.</p>
            </div>
          </div>

          <!-- Item 3 -->
          <div class="benefit-card">
            <div class="benefit-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            </div>
            <div class="benefit-content">
              <h3>Eficácia e Economia de Tempo</h3>
              <p>Avaliações instantâneas com bioinformação imediata, otimizando sua consulta e a experiência do paciente.</p>
            </div>
          </div>

          <!-- Item 4 -->
          <div class="benefit-card">
            <div class="benefit-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"/><line x1="16" y1="8" x2="2" y2="22"/><line x1="17.5" y1="15" x2="9" y2="15"/></svg>
            </div>
            <div class="benefit-content">
              <h3>Não Invasivo e Indolor</h3>
              <p>Teste via derme, sem agulhas ou extração de sangue. Ideal para toda a população sensível, incluindo crianças.</p>
            </div>
          </div>

          <!-- Item 5 -->
          <div class="benefit-card">
            <div class="benefit-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18"/><path d="m19 9-5 5-4-4-3 3"/></svg>
            </div>
            <div class="benefit-content">
              <h3>Acompanhamento de Pacientes</h3>
              <p>A plataforma SO/Check guarda o histórico para comparar testes e avaliar o progresso de cada paciente.</p>
            </div>
          </div>

          <!-- Item 6 -->
          <div class="benefit-card">
            <div class="benefit-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
            </div>
            <div class="benefit-content">
              <h3>Tratamentos Otimizados</h3>
              <p>Prescreva tratamentos mais eficientes e adequados com base em dados precisos e necessidades individuais.</p>
            </div>
          </div>
        </div>

        <div class="benefits-cta-wrapper">
          <button class="botao-secundario">
            Descubra Mais Informações
          </button>
        </div>
      </div>
    </section>

    <!-- Quem Somos (Global Presence) -->
    <section class="about-section">
      <div class="globe-wrapper">
        <AdminGlobe />
      </div>

      <div class="container about-content">
        <div class="badge-about">Presença Global</div>
        <h2>Quem <span class="texto-azul">Somos?</span></h2>
        <p class="about-text">
          OligoCheck está há mais de <strong class="texto-azul">10 anos no mercado mundial</strong>, presente em toda a Europa, África e América Latina. Somos a empresa pioneira na criação deste sistema revolucionário de análise mineral e detecção de metais pesados.
        </p>
        
        <div class="about-stats">
          <div class="stat-item">
            <strong>+45</strong>
            <span>Países</span>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <strong>+10 Anos</strong>
            <span>De Inovação</span>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <strong>Pioneiros</strong>
            <span>Tecnologia Patenteada</span>
          </div>
        </div>
      </div>
    </section>

    <!-- Depoimentos / Prova Social -->
    <section class="testimonials-section">
      <div class="container">
        <div class="section-header">
          <div class="badge-users">Quem usa recomenda</div>
          <h2 class="titulo-depoimentos">Junte-se aos Líderes da <span class="texto-azul">Saúde Integrativa</span></h2>
          <p class="subtitulo-depoimentos">Veja o impacto do OligoCheck na prática clínica de quem já utiliza.</p>
        </div>

        <div class="testimonials-grid">
          <!-- Depoimento 1 -->
          <div class="testim-card">
            <div class="testim-header">
              <div class="testim-avatar">
                <img src="@/assets/images/foto-pessoa-exemplo.png" alt="Dra. Juliana" />
              </div>
              <div class="testim-info">
                <strong>Dra. Juliana Mendes</strong>
                <span>Nutricionista Funcional</span>
              </div>
              <div class="testim-stars">★★★★★</div>
            </div>
            <p class="testim-text">
              "O OligoCheck mudou minha consulta. Antes eu esperava dias pelo exame de sangue, hoje já saio com a conduta pronta na primeira consulta. O paciente fica impressionado com a tecnologia."
            </p>
          </div>

          <!-- Depoimento 2 -->
          <div class="testim-card destaque">
            <div class="testim-header">
              <div class="testim-avatar">
                <img src="@/assets/images/medicos.png" alt="Dr. Ricardo" style="object-fit: cover; object-position: top;" />
              </div>
              <div class="testim-info">
                <strong>Dr. Ricardo Silva</strong>
                <span>Médico do Esporte</span>
              </div>
              <div class="testim-stars">★★★★★</div>
            </div>
            <p class="testim-text">
              "Aumentou meu ticket médio em 40%. É uma ferramenta visual poderosa que facilita a explicação da necessidade de suplementação. O retorno do investimento foi em menos de 2 meses."
            </p>
          </div>

          <!-- Depoimento 3 -->
          <div class="testim-card">
            <div class="testim-header">
              <div class="testim-avatar">
                <!-- Usando placeholder, ideal trocar por foto real -->
                <div class="avatar-placeholder">MF</div>
              </div>
              <div class="testim-info">
                <strong>Dra. Maria Fernanda</strong>
                <span>Dermatologista</span>
              </div>
              <div class="testim-stars">★★★★★</div>
            </div>
            <p class="testim-text">
              "Uso para avaliar estresse oxidativo e metais pesados em pacientes com melasma resistente. Os resultados são muito fidedignos e ajudam a tratar a causa raiz."
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ Section -->
    <section class="faq-section">
      <div class="container">
        <div class="section-header">
          <div class="badge-tech">Dúvidas Frequentes</div>
          <h2>Perguntas <span class="texto-azul">Comuns</span></h2>
          <p>Tire suas dúvidas sobre a tecnologia e o funcionamento do OligoCheck.</p>
        </div>

        <div class="faq-grid">
          <div 
            v-for="(item, index) in faqItems" 
            :key="index" 
            class="faq-item" 
            :class="{ active: activeFaq === index }"
            @click="toggleFaq(index)"
          >
            <div class="faq-question">
              <span>{{ item.question }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="faq-icon"><path d="m6 9 6 6 6-6"/></svg>
            </div>
            <div class="faq-answer">
              <p>{{ item.answer }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Final -->
    <section class="cta-final">
      <div class="container">
        <h2>Leve o OligoCheck para sua Clínica</h2>
        <p>Fale com um de nossos consultores e conheça as condições especiais.</p>
        <a href="https://api.whatsapp.com/send/?phone=34617488404" target="_blank" class="botao-principal laranja grande">
          Falar com Consultor
        </a>
      </div>
    </section>

    <footer class="footer">
      <div class="social-footer">
        <a href="#" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/></svg></a>
        <a href="#" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect width="4" height="12" x="2" y="9"/><circle cx="4" cy="4" r="2"/></svg></a>
      </div>
      <p>© {{ new Date().getFullYear() }} OligoCheck. Todos os direitos reservados.</p>
    </footer>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import AdminGlobe from '@/components/admin/partials/AdminGlobe.vue'

const theme = ref('dark')

const toggleTheme = () => {
  theme.value = theme.value === 'dark' ? 'light' : 'dark'
}

// FAQ Logic
const activeFaq = ref(null)

const toggleFaq = (index) => {
  activeFaq.value = activeFaq.value === index ? null : index
}

const faqItems = [
  {
    question: "O OligoCheck possui registro na ANVISA?",
    answer: "Sim, o OligoCheck é devidamente registrado na ANVISA, garantindo conformidade com todas as normas brasileiras de segurança e eficácia para uso profissional."
  },
  {
    question: "Qual a diferença para um exame de sangue?",
    answer: "O exame de sangue mede o nível extracelular (o que circula no sangue), que pode ser transitório. O OligoCheck mede a nível intracelular (tecido), mostrando o 'estoque' real de minerais e a intoxicação acumulada por metais pesados."
  },
  {
    question: "Preciso de internet para utilizar?",
    answer: "Sim. O OligoCheck opera conectado à plataforma SO/Check na nuvem. Isso garante que seus laudos estejam sempre seguros, acessíveis de qualquer lugar e com o software sempre atualizado na última versão."
  },
  {
    question: "Existe custo por teste ou mensalidade?",
    answer: "Trabalhamos com um modelo flexível que se adapta ao volume da sua clínica. Você adquire o equipamento e tem opções de pacotes de licenças. Entre em contato com nosso consultor para uma simulação personalizada."
  },
  {
    question: "Como funciona o treinamento?",
    answer: "Oferecemos treinamento completo para você e sua equipe. Inclui instalação, operação do software, interpretação dos laudos e dicas de como aplicar na prática clínica."
  }
]
</script>

<style scoped>
/* Variáveis CSS Scoped para Tema */
.landing-container {
  /* Default Dark Theme Variables */
  --bg-page: var(--cor-escuro-1);
  --bg-gradient-1: rgba(20, 203, 240, 0.08);
  --bg-gradient-2: rgba(245, 130, 32, 0.05);
  
  --text-primary: var(--cor-branco);
  --text-secondary: rgba(255, 255, 255, 0.6);
  --text-nav: rgba(255, 255, 255, 0.7);
  
  --nav-bg: rgba(10, 26, 42, 0.7);
  --nav-border: rgba(255, 255, 255, 0.08);
  
  --card-bg: rgba(255, 255, 255, 0.03);
  --card-border: rgba(255, 255, 255, 0.05);
  --card-hover-bg: rgba(255, 255, 255, 0.05);
  
  --badge-bg: rgba(255, 255, 255, 0.05);
  --badge-border: rgba(255, 255, 255, 0.1);
  --badge-text: var(--cor-azul);
  
  --divider: rgba(255, 255, 255, 0.1);
  --stats-border: rgba(255, 255, 255, 0.05);
  
  --step-number-bg: var(--cor-escuro-2);
  --step-number-border: rgba(255, 255, 255, 0.1);
  
  --cta-bg: linear-gradient(180deg, transparent 0%, rgba(20, 203, 240, 0.05) 100%);
  
  --icon-btn-hover: rgba(255, 255, 255, 0.05);
  --icon-bg-opacity: 0.1;
  
  /* Botão Laranja no Dark Mode */
  --btn-primary-bg: #f58220;
  --btn-primary-shadow: rgba(245, 130, 32, 0.4);
  --btn-primary-hover-shadow: rgba(245, 130, 32, 0.6);
  
  transition: background-color 0.5s ease;
}

/* Light Theme Overrides */
.landing-container.light {
  --bg-page: #f0f2f5;
  --bg-gradient-1: rgba(20, 203, 240, 0.08);
  --bg-gradient-2: rgba(245, 130, 32, 0.05);
  
  --text-primary: #0a1a2a;
  --text-secondary: #374151;
  --text-nav: #4b5563;
  
  --nav-bg: rgba(255, 255, 255, 0.85);
  --nav-border: rgba(0, 0, 0, 0.08);
  
  --card-bg: #ffffff;
  --card-border: rgba(0, 0, 0, 0.06);
  --card-hover-bg: #ffffff;
  
  --badge-bg: rgba(20, 203, 240, 0.1);
  --badge-border: rgba(20, 203, 240, 0.3);
  --badge-text: #006b99;
  
  --divider: rgba(0, 0, 0, 0.15);
  --stats-border: rgba(0, 0, 0, 0.08);
  
  --step-number-bg: #ffffff;
  --step-number-border: rgba(0, 0, 0, 0.15);
  
  --cta-bg: linear-gradient(180deg, transparent 0%, rgba(20, 203, 240, 0.05) 100%);
  
  --icon-btn-hover: rgba(0, 0, 0, 0.08);
  --icon-bg-opacity: 0.15;
  
  /* Botão Azul no Light Mode */
  --btn-primary-bg: var(--cor-azul);
  --btn-primary-shadow: rgba(20, 203, 240, 0.4);
  --btn-primary-hover-shadow: rgba(20, 203, 240, 0.6);
}

/* Bases */
.landing-container {
  min-height: 100vh;
  width: 100%;
  background-color: var(--bg-page);
  background-image: 
    radial-gradient(circle at 15% 15%, var(--bg-gradient-1) 0%, transparent 40%),
    radial-gradient(circle at 85% 85%, var(--bg-gradient-2) 0%, transparent 40%);
  font-family: var(--regular);
  color: var(--text-primary);
  overflow-x: hidden;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Navbar Flutuante */
.nav-wrapper {
  position: fixed;
  top: 20px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 100;
  padding: 0 40px;
}

.floating-nav {
  background: var(--nav-bg);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid var(--nav-border);
  border-radius: 100px;
  padding: 10px 10px 10px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  box-shadow: 0 10px 40px -10px rgba(0, 0, 0, 0.1);
  max-width: 1100px;
  width: 100%;
  transition: all 0.3s ease;
}

.nav-logo img {
  height: 24px;
}

.nav-links {
  display: flex;
  gap: 40px;
}

.nav-link {
  color: var(--text-nav);
  text-decoration: none;
  font-size: 15px;
  font-family: var(--regular);
  transition: all 0.2s;
  position: relative;
  font-weight: 500;
}

.nav-link:hover {
  color: var(--text-primary);
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 0;
  height: 2px;
  background: var(--cor-azul);
  transition: width 0.3s;
}

.nav-link:hover::after {
  width: 100%;
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.icon-btn {
  background: none;
  border: none;
  color: var(--text-nav);
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-btn:hover {
  color: var(--text-primary);
  background: var(--icon-btn-hover);
}

.divider {
  width: 1px;
  height: 24px;
  background: var(--divider);
}

.lang-selector {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 20px;
  transition: background 0.2s;
}

.lang-selector:hover {
  background: var(--icon-btn-hover);
}

.lang-selector .flag {
  width: 20px;
  border-radius: 2px;
}

.lang-selector svg {
  color: var(--text-secondary);
}

.nav-cta {
  background: var(--btn-primary-bg);
  color: var(--cor-branco);
  text-decoration: none;
  padding: 12px 32px;
  border-radius: 100px;
  font-family: var(--bold);
  font-size: 14px;
  transition: all 0.3s;
}

.nav-cta:hover {
  filter: brightness(1.1);
  transform: translateY(-1px);
}

/* Hero Section */
.hero {
  padding: 180px 0 100px;
  position: relative;
  overflow: visible;
}

.hero-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  animation: fadeIn 1s ease-out;
  text-align: left; /* Alinhamento à esquerda para 2 colunas */
}

.hero-text-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.badge {
  background: var(--badge-bg);
  border: 1px solid var(--badge-border);
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-bottom: 24px;
  color: var(--badge-text);
  backdrop-filter: blur(5px);
}

.titulo {
  font-family: var(--estilo);
  font-size: 56px; /* Ajuste leve para caber melhor */
  line-height: 1.1;
  margin-bottom: 24px;
  color: var(--text-primary);
}

.destaque-texto {
  color: var(--cor-azul);
}

.subtitulo {
  font-size: 18px;
  line-height: 1.6;
  color: var(--text-secondary);
  max-width: 600px;
  margin-bottom: 48px;
}

.cta-group {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: flex-start; /* Alinhamento à esquerda */
}

.hero-image-container {
  margin-top: 0; /* Remove margem top pois agora é coluna */
  position: relative;
  width: 100%;
  perspective: 1000px;
}

.hero-device-img {
  width: 100%;
  height: auto;
  border-radius: 12px;
  filter: drop-shadow(0 20px 50px rgba(0, 0, 0, 0.5));
  position: relative;
  z-index: 2;
  transform: rotateY(-10deg) rotateX(5deg); /* Angulação para "olhar" para o texto */
  transition: transform 0.5s ease;
}

.hero-image-container:hover .hero-device-img {
  transform: rotateY(0deg) rotateX(0deg) scale(1.02);
}

.hero-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120%;
  height: 80%;
  background: radial-gradient(circle, rgba(20, 203, 240, 0.15) 0%, transparent 70%);
  z-index: 1;
  pointer-events: none;
}

/* Nova Seção: Como Funciona */
.como-funciona {
  padding: 80px 0;
  background: var(--bg-page);
}

.cf-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.cf-text {
  text-align: left;
}

.section-title {
  font-family: var(--estilo);
  font-size: 40px;
  color: var(--text-primary);
  margin-bottom: 24px;
}

.cf-desc {
  font-size: 18px;
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: 40px;
}

.cf-features {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.cf-feature-item {
  display: flex;
  align-items: center;
  gap: 16px;
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  padding: 16px;
  border-radius: 16px;
  transition: all 0.3s;
}

.cf-feature-item:hover {
  border-color: var(--text-secondary);
  transform: translateY(-2px);
}

.cf-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(20, 203, 240, 0.1);
  color: var(--cor-azul);
}

.cf-icon.warning { background: rgba(245, 130, 32, 0.1); color: #f58220; }
.cf-icon.success { background: rgba(26, 175, 149, 0.1); color: var(--cor-ciano); }
.cf-icon.info { background: rgba(138, 43, 226, 0.1); color: #8a2be2; }

.cf-info {
  display: flex;
  flex-direction: column;
}

.cf-info strong {
  color: var(--text-primary);
  font-size: 16px;
  font-family: var(--bold);
}

.cf-info span {
  color: var(--text-secondary);
  font-size: 12px;
}

/* Visual Report Placeholder */
.cf-image-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
}

.report-card {
  width: 100%;
  max-width: 400px;
  height: auto; /* Altura automática para se ajustar à imagem */
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 12px; /* Padding reduzido para a imagem aproveitar o espaço */
  position: relative;
  z-index: 2;
  box-shadow: 0 20px 50px rgba(0,0,0,0.3);
  overflow: hidden; /* Garante que a imagem respeite o border-radius */
}

.report-img {
  width: 100%;
  height: auto;
  border-radius: 16px;
  display: block;
}

/* Overlay de Visualização */
.report-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s ease;
  cursor: pointer;
}

.report-card:hover .report-overlay {
  opacity: 1;
}

.btn-visualizar {
  background: var(--cor-branco);
  color: var(--cor-escuro-1);
  border: none;
  padding: 12px 24px;
  border-radius: 50px;
  font-family: var(--bold);
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  transform: translateY(10px);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}

.report-card:hover .btn-visualizar {
  transform: translateY(0);
}

.btn-visualizar:hover {
  transform: scale(1.05) !important;
  background: #f8f8f8;
}

.floating-anim {
  animation: float 6s ease-in-out infinite;
}

.glow-effect {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120%;
  height: 80%;
  background: radial-gradient(circle, rgba(20, 203, 240, 0.2) 0%, transparent 70%);
  z-index: 1;
}

@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0px); }
}

@keyframes pulseWidth {
  0% { width: 40%; }
  50% { width: 90%; }
  100% { width: 40%; }
}

@keyframes growWidth {
  from { width: 0; }
}

/* Botões */
.botao-principal {
  background: var(--btn-primary-bg);
  color: var(--cor-branco);
  border: none;
  padding: 16px 32px;
  border-radius: 100px;
  font-family: var(--bold);
  font-size: 16px;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 8px 20px -4px var(--btn-primary-shadow);
  animation: pulse-botao 2s infinite;
}

.botao-principal.grande {
  padding: 20px 40px;
  font-size: 18px;
}

.botao-principal:hover {
  filter: brightness(1.1);
  transform: translateY(-2px);
  box-shadow: 0 12px 28px -6px var(--btn-primary-hover-shadow);
  animation: none;
}

.botao-secundario {
  background: transparent;
  color: var(--text-primary);
  border: 1px solid var(--divider);
  padding: 16px 32px;
  border-radius: 100px;
  font-family: var(--bold);
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
}

.botao-secundario:hover {
  background: var(--icon-btn-hover);
  border-color: var(--text-secondary);
}


/* Steps Section */
.steps-section {
  padding: 100px 0;
  background: var(--card-bg);
  border-top: 1px solid var(--divider);
  border-bottom: 1px solid var(--divider);
}

.steps-grid {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 80px;
  position: relative;
  gap: 20px;
}

.step-item {
  text-align: center;
  flex: 1;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.step-icon-wrapper {
  position: relative;
  margin-bottom: 32px;
}

.step-icon {
  width: 80px;
  height: 80px;
  background: var(--nav-bg);
  border: 1px solid var(--cor-azul);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--cor-azul);
  box-shadow: 0 0 20px rgba(20, 203, 240, 0.2);
  transition: all 0.3s ease;
}

.step-item:hover .step-icon {
  transform: translateY(-5px);
  background: rgba(20, 203, 240, 0.1);
  box-shadow: 0 0 30px rgba(20, 203, 240, 0.4);
}

.step-number {
  width: 30px;
  height: 30px;
  background: #f58220;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -10px;
  right: -10px;
  font-family: var(--bold);
  font-size: 14px;
  color: #fff;
  border: 2px solid var(--bg-page);
  z-index: 3;
}

.step-connector {
  flex: 1;
  height: 2px;
  background: var(--divider);
  margin-top: 40px;
  position: relative;
  overflow: hidden;
}

.line-anim {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--cor-azul);
  transform: translateX(-100%);
  animation: slideLine 3s infinite linear;
}

.delay-1 { animation-delay: 1s; }
.delay-2 { animation-delay: 2s; }

@keyframes slideLine {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

.step-item h4 {
  font-family: var(--estilo);
  font-size: 20px;
  margin-bottom: 12px;
  color: var(--text-primary);
}

.step-item p {
  font-size: 15px;
  color: var(--text-secondary);
  line-height: 1.6;
  max-width: 240px;
}

/* Science Section */
.science-section {
  padding: 120px 0;
  position: relative;
  overflow: hidden;
  background: var(--card-bg);
  border-top: 1px solid var(--divider);
  border-bottom: 1px solid var(--divider);
}

.science-content {
  display: flex;
  align-items: center;
  gap: 80px;
}

.science-visual {
  flex: 1;
  height: 500px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle at center, rgba(20, 203, 240, 0.05) 0%, transparent 70%);
  border-radius: 30px;
}

.device-showcase {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.device-img {
  max-width: 80%;
  max-height: 80%;
  object-fit: contain;
  position: relative;
  z-index: 2;
  filter: drop-shadow(0 20px 40px rgba(0,0,0,0.3));
  transition: transform 0.3s ease;
}

.device-showcase:hover .device-img {
  transform: scale(1.05);
}

.device-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60%;
  height: 60%;
  background: radial-gradient(circle, rgba(20, 203, 240, 0.2) 0%, transparent 70%);
  z-index: 1;
  animation: pulseGlow 4s infinite ease-in-out;
}

@keyframes pulseGlow {
  0%, 100% { opacity: 0.5; transform: translate(-50%, -50%) scale(0.9); }
  50% { opacity: 0.8; transform: translate(-50%, -50%) scale(1.1); }
}

/* Antiga animação removida, mantendo compatibilidade se necessário */
.process-animation {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
}

/* Stage 1: Hand & Scanner */
.stage-hand {
  position: relative;
  width: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hand-wrapper {
  position: relative;
  width: 100px;
  height: 100px;
  color: rgba(255, 255, 255, 0.2);
  animation: handFade 8s infinite;
}

.hand-icon {
  width: 100%;
  height: 100%;
}

.cells-group {
  position: absolute;
  top: 30%;
  left: 20%;
  width: 60%;
  height: 50%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;
}

.cell {
  width: 6px;
  height: 6px;
  background: var(--cor-azul);
  border-radius: 50%;
  opacity: 0;
  box-shadow: 0 0 5px var(--cor-azul);
  animation: cellGlow 8s infinite;
}

.cell:nth-child(1) { animation-delay: 2.1s; }
.cell:nth-child(2) { animation-delay: 2.3s; }
.cell:nth-child(3) { animation-delay: 2.5s; }
.cell:nth-child(4) { animation-delay: 2.2s; }
.cell:nth-child(5) { animation-delay: 2.4s; }
.cell:nth-child(6) { animation-delay: 2.6s; }

.scanner-beam {
  position: absolute;
  top: 120%;
  left: 50%;
  width: 4px;
  height: 0;
  background: linear-gradient(to top, transparent, #f58220);
  transform: translateX(-50%);
  box-shadow: 0 0 10px #f58220;
  animation: beamShoot 8s infinite;
}

/* Data Path */
.data-path {
  flex: 1;
  height: 2px;
  background: rgba(255, 255, 255, 0.1);
  margin: 0 20px;
  position: relative;
  overflow: hidden;
}

.data-particle {
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 100%;
  background: linear-gradient(90deg, transparent, var(--cor-azul), transparent);
  transform: translateX(-100%);
  animation: dataFlow 8s infinite;
  animation-delay: 3.5s; /* Começa depois das células */
}

/* Stage 2: Algorithm */
.stage-algo {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.algo-label {
  font-size: 10px;
  text-transform: uppercase;
  color: var(--text-secondary);
  opacity: 0;
  animation: fadeInOut 8s infinite;
  animation-delay: 4.5s;
}

.algo-icon {
  width: 60px;
  height: 60px;
  color: var(--text-secondary);
  position: relative;
  z-index: 2;
  transition: color 0.3s;
  animation: algoPulse 8s infinite;
  animation-delay: 4.5s;
}

.algo-waves {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 1px solid var(--cor-azul);
  opacity: 0;
  animation: ripple 8s infinite;
  animation-delay: 4.5s;
}

/* Stage 3: Result */
.stage-result {
  position: absolute;
  top: 20%;
  right: 10%;
  opacity: 0;
  animation: resultPop 8s infinite;
  animation-delay: 6s;
}

.result-card-mini {
  background: var(--nav-bg);
  backdrop-filter: blur(10px);
  border: 1px solid var(--cor-azul);
  padding: 16px;
  border-radius: 12px;
  width: 140px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}

.res-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.res-row span {
  font-size: 10px;
  font-family: var(--bold);
  width: 20px;
}

.res-bar {
  height: 3px;
  border-radius: 2px;
  width: 0;
  animation: growBar 8s infinite;
  animation-delay: 6.2s;
}

.b1 { background: var(--cor-azul); max-width: 80%; }
.b2 { background: #f58220; max-width: 60%; }
.b3 { background: #27c93f; max-width: 90%; }

/* Keyframes Timeline (8s loop) */
@keyframes handFade {
  0% { opacity: 0.5; transform: scale(0.95); }
  10% { opacity: 1; transform: scale(1); } /* 0.8s */
  40% { opacity: 1; }
  90% { opacity: 0.5; transform: scale(0.95); }
}

@keyframes beamShoot {
  0%, 15% { height: 0; opacity: 0; bottom: 0; }
  20% { height: 60px; opacity: 1; top: 100%; } /* Sobe */
  30% { height: 0; opacity: 0; top: 40%; } /* Entra na mão */
  100% { height: 0; opacity: 0; }
}

@keyframes cellGlow {
  0%, 25% { opacity: 0; transform: scale(0); }
  35% { opacity: 1; transform: scale(1.5); } /* Brilha */
  45% { opacity: 0; transform: scale(1); }
  100% { opacity: 0; }
}

@keyframes dataFlow {
  0% { transform: translateX(-100%); opacity: 0; }
  10% { opacity: 1; }
  90% { transform: translateX(400%); opacity: 0; }
  100% { opacity: 0; }
}

@keyframes algoPulse {
  0%, 50% { color: var(--text-secondary); transform: scale(1); }
  60% { color: var(--cor-azul); transform: scale(1.2); }
  70% { color: var(--text-secondary); transform: scale(1); }
}

@keyframes ripple {
  0%, 50% { width: 60px; height: 60px; opacity: 0; }
  60% { opacity: 0.5; }
  80% { width: 120px; height: 120px; opacity: 0; }
}

@keyframes resultPop {
  0%, 70% { opacity: 0; transform: translateY(20px); }
  75% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-10px); }
}

@keyframes growBar {
  0%, 75% { width: 0; }
  85% { width: 100%; } /* Cresce até o max-width definido */
  100% { width: 100%; }
}

@keyframes fadeInOut {
  0%, 50% { opacity: 0; }
  60% { opacity: 1; }
  80% { opacity: 0; }
}

.science-text { flex: 1; }

.badge-science {
  display: inline-block;
  color: #8a2be2;
  border: 1px solid rgba(138, 43, 226, 0.3);
  padding: 6px 12px;
  border-radius: 100px;
  font-size: 12px;
  margin-bottom: 24px;
  background: rgba(138, 43, 226, 0.05);
}

.science-text h2 {
  font-family: var(--estilo);
  font-size: 40px;
  margin-bottom: 24px;
  color: var(--text-primary);
}

.science-intro {
  font-size: 18px;
  line-height: 1.6;
  color: var(--text-secondary);
  margin-bottom: 32px;
}

.science-features {
  margin-bottom: 40px;
}

.sc-item {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.sc-dot {
  width: 6px;
  height: 6px;
  background: var(--cor-azul);
  border-radius: 50%;
  margin-top: 10px;
  box-shadow: 0 0 10px var(--cor-azul);
}

.sc-item p {
  font-size: 15px;
  color: var(--text-secondary);
  line-height: 1.6;
  flex: 1;
}

.articles-card {
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  border-radius: 16px;
  padding: 24px;
}

.art-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  color: var(--text-primary);
  font-family: var(--bold);
}

.art-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.article-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  text-decoration: none;
  color: var(--text-secondary);
  font-size: 14px;
  transition: all 0.2s;
}

.article-link:hover {
  background: rgba(255, 255, 255, 0.08);
  color: var(--text-primary);
  transform: translateX(5px);
}

@keyframes beamPulse {
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
}

@media (max-width: 900px) {
  .science-content { flex-direction: column; gap: 40px; }
  .science-visual { width: 100%; height: 300px; }
}

/* Comparativo Section */
.comparative-section {
  padding: 100px 0;
  background: var(--bg-page);
  position: relative;
}

.comparison-table-wrapper {
  overflow-x: auto;
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  border-radius: 24px;
  padding: 24px;
  box-shadow: 0 20px 50px rgba(0,0,0,0.1);
}

.comparison-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 600px;
}

.comparison-table th {
  padding: 24px;
  text-align: left;
  border-bottom: 1px solid var(--divider);
  font-family: var(--estilo);
  font-size: 20px;
  color: var(--text-primary);
}

.comparison-table td {
  padding: 24px;
  border-bottom: 1px solid var(--divider);
  vertical-align: top;
}

.comparison-table tr:last-child td {
  border-bottom: none;
}

.feature-col { width: 25%; }
.traditional-col { width: 37.5%; background: rgba(255, 255, 255, 0.01); }
.oligocheck-col { width: 37.5%; background: rgba(20, 203, 240, 0.03); border-radius: 16px; }

.logo-th img {
  height: 24px;
}

.feature-name {
  font-family: var(--bold);
  font-size: 16px;
  color: var(--text-primary);
  padding-top: 28px !important;
}

.status-tag {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 100px;
  font-size: 13px;
  font-family: var(--bold);
  margin-bottom: 8px;
}

.status-tag.success {
  background: rgba(26, 175, 149, 0.15);
  color: var(--cor-ciano);
  border: 1px solid rgba(26, 175, 149, 0.3);
}

.status-tag.warning {
  background: rgba(245, 130, 32, 0.15);
  color: #f58220;
  border: 1px solid rgba(245, 130, 32, 0.3);
}

.status-tag.neutral {
  background: rgba(255, 255, 255, 0.1);
  color: var(--text-secondary);
  border: 1px solid var(--divider);
}

.comparison-table small {
  display: block;
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.4;
}

/* Responsivo Tabela */
@media (max-width: 768px) {
  .comparison-table-wrapper { padding: 16px; }
  .comparison-table th, .comparison-table td { padding: 16px; }
  .feature-name { font-size: 14px; }
  .logo-th img { height: 20px; }
}

/* Benefits Section */
.benefits-section {
  padding: 100px 0;
  background: var(--bg-page);
  position: relative;
}

.badge-users {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(20, 203, 240, 0.1);
  color: var(--cor-azul);
  padding: 8px 16px;
  border-radius: 100px;
  font-size: 14px;
  font-family: var(--bold);
  margin-bottom: 24px;
  border: 1px solid rgba(20, 203, 240, 0.2);
}

.benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

.benefit-card {
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  border-radius: 20px;
  padding: 30px;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.benefit-card:hover {
  background: var(--card-hover-bg);
  border-color: var(--text-secondary);
  transform: translateY(-5px);
  box-shadow: 0 15px 40px -10px rgba(0,0,0,0.1);
}

.benefit-icon {
  min-width: 50px;
  height: 50px;
  background: var(--nav-bg);
  border: 1px solid var(--cor-azul);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--cor-azul);
  box-shadow: 0 4px 12px rgba(20, 203, 240, 0.15);
  transition: all 0.3s;
}

.benefit-card:hover .benefit-icon {
  background: var(--cor-azul);
  color: #fff;
  transform: scale(1.1);
}

.benefit-content h3 {
  font-family: var(--bold);
  font-size: 18px;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.benefit-content p {
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.6;
}

.benefits-cta-wrapper {
  text-align: center;
  margin-top: 40px;
}

/* Responsivo Benefits */
@media (max-width: 768px) {
  .benefits-grid {
    grid-template-columns: 1fr;
  }
  
  .benefit-card {
    flex-direction: column;
    text-align: center;
    align-items: center;
  }
}

/* About Section */
.about-section {
  padding: 120px 0;
  background: var(--cor-escuro-1);
  position: relative;
  overflow: hidden;
  text-align: center;
  min-height: 600px; /* Garante altura para o globo */
}

.globe-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 120%; /* Um pouco maior para cortar as bordas se necessário */
  opacity: 0.4; /* Sutil no fundo */
  pointer-events: none;
  z-index: 1;
}

.about-content {
  position: relative;
  z-index: 2;
  max-width: 800px;
  background: radial-gradient(circle, rgba(1, 13, 24, 0.6) 0%, transparent 80%);
  padding: 40px;
  border-radius: 40px;
  backdrop-filter: blur(2px); /* Leve desfoque para separar texto do globo */
}

.badge-about {
  display: inline-block;
  color: var(--cor-branco);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 6px 16px;
  border-radius: 100px;
  font-size: 12px;
  margin-bottom: 24px;
  background: rgba(255, 255, 255, 0.05);
  letter-spacing: 1px;
  text-transform: uppercase;
}

.about-section h2 {
  font-family: var(--estilo);
  font-size: 48px;
  margin-bottom: 32px;
  color: var(--cor-branco);
}

.about-text {
  font-size: 20px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 60px;
}

.about-stats {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.stat-item strong {
  font-family: var(--estilo);
  font-size: 32px;
  color: var(--cor-azul);
}

.stat-item span {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.stat-divider {
  width: 1px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
}

@media (max-width: 768px) {
  .about-stats {
    flex-direction: column;
    gap: 24px;
  }
  
  .stat-divider {
    width: 40px;
    height: 1px;
  }
}

/* Depoimentos Section */
.testimonials-section {
  padding: 100px 0;
  background: var(--bg-page);
  position: relative;
}

.testimonials-section .section-header {
  text-align: center;
  max-width: 800px;
  margin: 0 auto 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.titulo-depoimentos {
  font-family: var(--estilo);
  font-size: 40px;
  margin-bottom: 16px;
  color: var(--text-primary);
  line-height: 1.2;
}

.subtitulo-depoimentos {
  font-size: 18px;
  color: var(--text-secondary);
  line-height: 1.6;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.testim-card {
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  padding: 30px;
  border-radius: 24px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.testim-card:hover {
  transform: translateY(-5px);
  border-color: var(--text-secondary);
  box-shadow: 0 10px 40px rgba(0,0,0,0.1);
}

.testim-card.destaque {
  background: linear-gradient(145deg, var(--card-bg), rgba(20, 203, 240, 0.05));
  border-color: rgba(20, 203, 240, 0.2);
}

.testim-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.testim-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid var(--cor-azul);
}

.testim-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  background: var(--cor-escuro-2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--cor-azul);
  font-family: var(--bold);
}

.testim-info {
  flex: 1;
}

.testim-info strong {
  display: block;
  font-family: var(--bold);
  font-size: 16px;
  color: var(--text-primary);
}

.testim-info span {
  font-size: 12px;
  color: var(--text-secondary);
}

.testim-stars {
  color: #f58220;
  letter-spacing: 2px;
  font-size: 14px;
}

.testim-text {
  font-size: 15px;
  line-height: 1.6;
  color: var(--text-secondary);
  font-style: italic;
}

/* FAQ Section */
.faq-section {
  padding: 100px 0;
  background: var(--bg-page);
}

.faq-grid {
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.faq-item {
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.faq-item:hover {
  border-color: var(--text-secondary);
}

.faq-item.active {
  border-color: var(--cor-azul);
  background: var(--card-hover-bg);
}

.faq-question {
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-family: var(--bold);
  font-size: 16px;
  color: var(--text-primary);
}

.faq-icon {
  color: var(--text-secondary);
  transition: transform 0.3s ease;
}

.faq-item.active .faq-icon {
  transform: rotate(180deg);
  color: var(--cor-azul);
}

.faq-answer {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out;
  padding: 0 24px;
}

.faq-item.active .faq-answer {
  max-height: 200px; /* Altura suficiente para o texto */
  padding-bottom: 24px;
}

.faq-answer p {
  color: var(--text-secondary);
  line-height: 1.6;
  font-size: 15px;
  border-top: 1px solid var(--divider);
  padding-top: 16px;
}

/* CTA Final */
.cta-final {
  padding: 100px 0;
  text-align: center;
  background: var(--cta-bg);
}

.cta-final h2 {
  font-family: var(--estilo);
  font-size: 40px;
  margin-bottom: 16px;
  color: var(--text-primary);
}

.cta-final p {
  color: var(--text-secondary);
  margin-bottom: 40px;
  font-size: 18px;
}

/* Footer */
.footer {
  text-align: center;
  padding: 40px 0;
  border-top: 1px solid var(--divider);
  color: var(--text-secondary);
  font-size: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
}

.social-footer {
  display: flex;
  gap: 16px;
}

.social-footer a {
  color: var(--text-nav);
  transition: color 0.3s;
}

.social-footer a:hover {
  color: var(--text-primary);
}

/* Animações */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes pulse-botao {
  0% { transform: scale(1); box-shadow: 0 8px 20px -4px var(--btn-primary-shadow); }
  50% { transform: scale(1.02); box-shadow: 0 12px 24px -4px var(--btn-primary-hover-shadow); }
  100% { transform: scale(1); box-shadow: 0 8px 20px -4px var(--btn-primary-shadow); }
}

@keyframes scan {
  0% { top: 20%; opacity: 0; }
  50% { opacity: 1; }
  100% { top: 80%; opacity: 0; }
}

/* Responsivo */
@media (max-width: 900px) {
  .nav-wrapper { top: auto; bottom: 20px; padding: 0 10px; }
  .floating-nav { flex-direction: column; gap: 16px; border-radius: 24px; padding: 20px; }
  .nav-links { display: none; }
  
  .titulo { font-size: 48px; }
  
  .cf-grid { grid-template-columns: 1fr; }
  .cf-text { text-align: center; }
  .cf-desc { margin-bottom: 30px; }
  .cf-image-wrapper { margin-top: 40px; }
  
  .steps-grid { flex-direction: column; align-items: center; gap: 20px; }
  .step-connector { display: none; }
  .step-item { margin-bottom: 30px; }
  
  .tech-content { flex-direction: column-reverse; }
}

@media (max-width: 480px) {
  .hero { padding: 80px 0 60px; }
  .titulo { font-size: 36px; }
  .card-analise { padding: 24px; }
  .cf-features { grid-template-columns: 1fr; }
}
</style>
}
